import React from "react";
import { useState, useEffect, Suspense } from "react";
import { Typography, CircularProgress } from "@material-ui/core";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { getAbout } from "../requests";
import { AboutInterface } from "../types";
import ReactMarkdown from "react-markdown";
import theme from "../styles";
import { Helmet } from "react-helmet";
const Researchers = React.lazy(() => import("../components/Researchers"));

const useStyles = makeStyles(
  createStyles({
    root: {
      padding: "90px 30px 30px",
    },
    aboutHeadings: {
      color: theme.palette.primary.main,
      padding: "5px",
      textAlign: "center",
    },
    mainText: {
      textAlign: "left",
      padding: "0px 1em 1em",
      fontSize: "large",
      [theme.breakpoints.up("lg")]: {
        paddingLeft: "10%",
        paddingRight: "10%",
      },
    },
  })
);

function AboutUs() {
  const classes = useStyles();
  const [isLoading, setLoading] = useState(true);
  const [aboutus, setAbout] = useState<AboutInterface>({
    project_title: "",
    description: "",
    aims_title: "",
    aims: "",
  });

  useEffect(() => {
    getAbout().then(() => {
      let localData = localStorage.getItem("about");
      if (localData) {
        const data: AboutInterface = JSON.parse(localData || "{}");
        setAbout({
          project_title: data.project_title,
          description: data.description,
          aims_title: data.aims_title,
          aims: data.aims,
        });
      }
      setLoading(false);
    });
  }, []);

  return (
    <div className={classes.root}>
      <Helmet>
        <title>About Us</title>
        <meta
          name="About Us Page"
          content="About digitalisation of charity services"
        />
      </Helmet>

      {isLoading ? (
        <CircularProgress />
      ) : (
        <>
          <Typography className={classes.aboutHeadings} variant="h2">
            About Us
          </Typography>
          <ReactMarkdown
            className={classes.mainText}
            children={aboutus.description}
          />
          <Typography className={classes.aboutHeadings} variant="h4">
            Meet Our Team
          </Typography>

          <Suspense fallback={<CircularProgress />}>
            <Researchers />
          </Suspense>
        </>
      )}
    </div>
  );
}

export default AboutUs;
